import { createSelector } from 'reselect';

const productRootSelector = state => state;

const stateSelector = createSelector(
  productRootSelector,
  state => ({
    updating: state.updating,
    fetchProductCommentsStart: state.fetchProductCommentsStart,
    bulkUpdateActivityLogsStart: state.bulkUpdateActivityLogsStart,
  }),
);

export const productSelector = createSelector(
  stateSelector,
  state => ({
    ...state,
  }),
);

export default {
  productSelector,
};
